import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { NotaFormInsertComponent } from './nota-form-insert.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        NotaFormInsertComponent
    ],
    exports: [
        NotaFormInsertComponent
    ]
})
export class NotaFormInsertModule { }
